/**
 * search.js — Aurum & Ash predictive search overlay
 *
 * Owns the header search modal. Reads recipes from the
 * #aa-recipes-index JSON blob (pre-rendered by aa-search-overlay.liquid).
 * Products and articles come from Shopify's /search/suggest.json.
 */
(function () {
  'use strict';

  var AA = window.AurumAsh = window.AurumAsh || {};
  if (AA.search) return;

  var overlay, input, form, results, placeholder, emptyEl, seeAll, seeAllQuery;
  var groupEls = {};
  var listEls = {};
  var recipes = null;          // lazy-parsed
  var debounceTimer = null;
  var fetchAbort = null;
  var open = false;

  function $(sel, root) { return (root || document).querySelector(sel); }

  function loadRecipes() {
    if (recipes !== null) return recipes;
    var el = document.getElementById('aa-recipes-index');
    if (!el) { recipes = []; return recipes; }
    try { recipes = JSON.parse(el.textContent) || []; }
    catch (e) { recipes = []; }
    return recipes;
  }

  function openOverlay() {
    if (open) return;
    open = true;
    overlay.hidden = false;
    // Force reflow so transition works
    overlay.offsetHeight; // jshint ignore:line
    overlay.classList.add('aa-search-overlay--open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeOverlay() {
    if (!open) return;
    open = false;
    overlay.classList.remove('aa-search-overlay--open');
    setTimeout(function () { overlay.hidden = true; }, 200);
    document.body.style.overflow = '';
    if (fetchAbort) { try { fetchAbort.abort(); } catch (e) {} fetchAbort = null; }
  }

  function escapeHTML(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function recipeMatches(r, q) {
    var hay = ((r.name || '') + ' ' + (r.atomic || '') + ' ' + (r.summary || '')).toLowerCase();
    return hay.indexOf(q) !== -1;
  }

  function searchRecipes(q) {
    var list = loadRecipes();
    var hits = [];
    for (var i = 0; i < list.length && hits.length < 4; i++) {
      if (recipeMatches(list[i], q)) hits.push(list[i]);
    }
    return hits;
  }

  function renderRecipes(hits) {
    var html = '';
    for (var i = 0; i < hits.length; i++) {
      var r = hits[i];
      var typeLabel = r.type === 'non_alcoholic' ? 'Non-alcoholic' : (r.type === 'component' ? 'Component' : 'Cocktail');
      var eyebrow = r.spirit ? typeLabel + ' · ' + escapeHTML(r.spirit) : typeLabel;
      html += '<li class="aa-search-overlay__item"><a href="' + escapeHTML(r.url) + '" class="aa-search-overlay__item-link">';
      if (r.image) html += '<img src="' + escapeHTML(r.image) + '" alt="" class="aa-search-overlay__item-img" loading="lazy">';
      else html += '<span class="aa-search-overlay__item-img aa-search-overlay__item-img--fallback"></span>';
      html += '<span class="aa-search-overlay__item-body"><span class="aa-search-overlay__item-eyebrow">' + eyebrow + '</span><span class="aa-search-overlay__item-title">' + escapeHTML(r.name) + '</span></span>';
      html += '</a></li>';
    }
    listEls.recipes.innerHTML = html;
    groupEls.recipes.hidden = hits.length === 0;
  }

  function renderProducts(items) {
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var p = items[i];
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var eyebrow = p.vendor || (p.product_type || 'Tool');
      html += '<li class="aa-search-overlay__item"><a href="' + escapeHTML(p.url) + '" class="aa-search-overlay__item-link">';
      if (img) html += '<img src="' + escapeHTML(img) + '" alt="" class="aa-search-overlay__item-img" loading="lazy">';
      else html += '<span class="aa-search-overlay__item-img aa-search-overlay__item-img--fallback"></span>';
      html += '<span class="aa-search-overlay__item-body"><span class="aa-search-overlay__item-eyebrow">' + escapeHTML(eyebrow) + '</span><span class="aa-search-overlay__item-title">' + escapeHTML(p.title) + '</span></span>';
      html += '</a></li>';
    }
    listEls.products.innerHTML = html;
    groupEls.products.hidden = items.length === 0;
  }

  function renderArticles(items) {
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var a = items[i];
      var img = a.image && a.image.url ? a.image.url : (a.image || '');
      var eyebrow = (a.author && a.author.name) ? 'Article · ' + escapeHTML(a.author.name) : 'Article';
      html += '<li class="aa-search-overlay__item"><a href="' + escapeHTML(a.url) + '" class="aa-search-overlay__item-link">';
      if (img) html += '<img src="' + escapeHTML(img) + '" alt="" class="aa-search-overlay__item-img" loading="lazy">';
      else html += '<span class="aa-search-overlay__item-img aa-search-overlay__item-img--fallback"></span>';
      html += '<span class="aa-search-overlay__item-body"><span class="aa-search-overlay__item-eyebrow">' + eyebrow + '</span><span class="aa-search-overlay__item-title">' + escapeHTML(a.title) + '</span></span>';
      html += '</a></li>';
    }
    listEls.articles.innerHTML = html;
    groupEls.articles.hidden = items.length === 0;
  }

  function showState(state) {
    placeholder.hidden = state !== 'placeholder';
    emptyEl.hidden = state !== 'empty';
    seeAll.hidden = state !== 'results';
    if (state !== 'results') {
      groupEls.recipes.hidden = true;
      groupEls.products.hidden = true;
      groupEls.articles.hidden = true;
    }
  }

  function runQuery(q) {
    if (q.length < 2) { showState('placeholder'); return; }

    // Recipes synchronous
    var recipeHits = searchRecipes(q);
    renderRecipes(recipeHits);

    // Native suggest.json fetch (products + articles in parallel)
    if (fetchAbort) { try { fetchAbort.abort(); } catch (e) {} }
    fetchAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var signal = fetchAbort ? fetchAbort.signal : undefined;

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product,article' +
              '&resources[limit]=4' +
              '&resources[options][unavailable_products]=last';

    fetch(url, { signal: signal })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var articles = (data && data.resources && data.resources.results && data.resources.results.articles) || [];
        renderProducts(products);
        renderArticles(articles.slice(0, 3));

        var any = recipeHits.length > 0 || products.length > 0 || articles.length > 0;
        if (any) {
          seeAllQuery.textContent = '"' + q + '"';
          seeAll.setAttribute('href', '/search?q=' + encodeURIComponent(q));
          showState('results');
        } else {
          showState('empty');
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        // Fall back to recipe-only results
        var any = recipeHits.length > 0;
        if (any) {
          seeAllQuery.textContent = '"' + q + '"';
          seeAll.setAttribute('href', '/search?q=' + encodeURIComponent(q));
          showState('results');
        } else {
          showState('empty');
        }
      });
  }

  function onInput() {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    debounceTimer = setTimeout(function () { runQuery(q); }, 200);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && open) {
      e.preventDefault();
      closeOverlay();
    }
  }

  function init() {
    overlay = $('[data-search-overlay]');
    if (!overlay) return;
    input = $('[data-search-input]', overlay);
    form = $('[data-search-form]', overlay);
    results = $('[data-search-results]', overlay);
    placeholder = $('[data-search-placeholder]', overlay);
    emptyEl = $('[data-search-empty]', overlay);
    seeAll = $('[data-search-see-all]', overlay);
    seeAllQuery = $('[data-search-see-all-query]', overlay);
    groupEls.recipes = $('[data-search-group="recipes"]', overlay);
    groupEls.products = $('[data-search-group="products"]', overlay);
    groupEls.articles = $('[data-search-group="articles"]', overlay);
    listEls.recipes = $('[data-search-list="recipes"]', overlay);
    listEls.products = $('[data-search-list="products"]', overlay);
    listEls.articles = $('[data-search-list="articles"]', overlay);

    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openOverlay);
    });
    document.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closeOverlay);
    });
    input.addEventListener('input', onInput);
    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  AA.search = { open: openOverlay, close: closeOverlay };
})();
